import React from 'react';

const OptionsIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="M12.842 1.573c.63 0 1.178.415 1.356 1.008l.032.13.301 1.517c.305.099.6.217.887.35l.285.139 1.288-.861a1.419 1.419 0 0 1 1.68.08l.107.096 1.191 1.19c.443.444.538 1.12.25 1.664l-.074.123-.86 1.286c.144.282.273.573.385.872l.106.303 1.512.3a1.414 1.414 0 0 1 1.133 1.254l.006.134v1.684c0 .63-.415 1.178-1.01 1.356l-.129.032-1.508.3c-.1.307-.219.604-.353.894l-.14.286.858 1.282c.348.52.31 1.203-.08 1.68l-.096.106-1.19 1.19a1.412 1.412 0 0 1-1.64.263l-.148-.086-1.28-.856a8.133 8.133 0 0 1-.877.388l-.305.106-.299 1.506a1.415 1.415 0 0 1-1.254 1.132l-.134.006h-1.685a1.414 1.414 0 0 1-1.354-1.008l-.032-.13-.299-1.506a7.913 7.913 0 0 1-.897-.354l-.287-.14-1.279.856a1.414 1.414 0 0 1-1.665-.067l-.122-.11-1.19-1.19a1.414 1.414 0 0 1-.25-1.663l.074-.123.856-1.282a8.452 8.452 0 0 1-.386-.876l-.106-.304-1.508-.3a1.416 1.416 0 0 1-1.133-1.255l-.006-.133v-1.684c0-.63.416-1.178 1.01-1.355l.13-.032 1.511-.301c.1-.305.218-.602.352-.89l.14-.285-.86-1.286a1.416 1.416 0 0 1 .08-1.68l.095-.107 1.191-1.19a1.411 1.411 0 0 1 1.64-.262l.147.086 1.288.86c.282-.142.572-.272.87-.383l.302-.105.302-1.517a1.415 1.415 0 0 1 1.253-1.132l.133-.006h1.685zm-.07 1.5h-1.544l-.459 2.309-.836.272a6.42 6.42 0 0 0-.715.283l-.24.117-.784.399-1.96-1.311-1.092 1.09 1.31 1.96-.4.785a6.755 6.755 0 0 0-.287.64l-.114.318-.273.835-2.305.458v1.544l2.303.458.272.837c.077.237.172.478.284.72l.117.24.4.785-1.307 1.955 1.092 1.092 1.953-1.307.785.402c.213.109.428.205.642.288l.321.114.836.272.457 2.299h1.544l.457-2.3.836-.271c.213-.07.429-.153.643-.249l.321-.153.784-.402 1.954 1.307 1.092-1.092-1.307-1.955.398-.783a6.97 6.97 0 0 0 .32-.724l.083-.238.271-.837 2.303-.458v-1.544l-2.305-.458-.273-.835a6.34 6.34 0 0 0-.247-.639l-.154-.32-.399-.783 1.31-1.96-1.092-1.091-1.96 1.31-.784-.398a6.994 6.994 0 0 0-.72-.318l-.236-.082-.836-.272-.459-2.31zM12 7.508a4.492 4.492 0 1 1 0 8.984 4.492 4.492 0 0 1 0-8.984zm0 1.5A2.996 2.996 0 0 0 9.007 12 2.996 2.996 0 0 0 12 14.993 2.996 2.996 0 0 0 14.992 12 2.996 2.996 0 0 0 12 9.008z" />
    </svg>
)

const ArrowUpIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="m12.002 5 5.656 5.666a.752.752 0 0 1 0 1.062.75.75 0 0 1-1.06 0L12.75 7.876v10.183a.75.75 0 1 1-1.5 0V7.876l-3.846 3.852a.75.75 0 0 1-1.06 0 .752.752 0 0 1 0-1.062L12.002 5z" />
    </svg>
)

const ArrowDownIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="m12.002 19.02 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0l-3.847 3.852V5.961a.75.75 0 1 0-1.5 0v10.183l-3.846-3.852a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" />
    </svg>
)

const ArrowLeftIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="m12.002 19.02 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0l-3.847 3.852V5.961a.75.75 0 1 0-1.5 0v10.183l-3.846-3.852a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" />
    </svg>
)

const ArrowRightIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="m12.002 19.02 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0l-3.847 3.852V5.961a.75.75 0 1 0-1.5 0v10.183l-3.846-3.852a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" />
    </svg>
)

const DeleteIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#F75E5E" fillRule="evenodd" d="M18.729 1.575c1.19 0 2.17.93 2.25 2.1l.005.155v.845c0 .982-.637 1.812-1.516 2.12l.015.126.01.127V19.16a3.27 3.27 0 0 1-3.08 3.26l-.186.005H7.761a3.269 3.269 0 0 1-3.26-3.08l-.005-.185V7.048c0-.088.013-.172.022-.257a2.256 2.256 0 0 1-1.495-1.945l-.006-.171V3.83c0-1.191.929-2.17 2.1-2.25l.154-.005h13.457zm-.747 5.354H6.008L6 6.989l-.005.059V19.16c0 .924.715 1.685 1.62 1.76l.145.005h8.466c.925 0 1.686-.715 1.76-1.62l.006-.145V7.048l-.005-.06-.006-.059zM8.253 8.292a.75.75 0 0 1 .743.648l.007.102v9.647a.75.75 0 0 1-1.493.102l-.007-.102V9.042a.75.75 0 0 1 .75-.75zm3.774 0a.75.75 0 0 1 .744.648l.006.102v9.647a.749.749 0 0 1-1.493.102l-.007-.102V9.042a.75.75 0 0 1 .75-.75zm3.776 0a.75.75 0 0 1 .743.648l.007.102v9.647a.75.75 0 0 1-1.493.102l-.007-.102V9.042a.75.75 0 0 1 .75-.75zm2.925-5.217H5.271a.757.757 0 0 0-.748.653l-.006.102v.845c0 .381.284.697.652.747l.103.007h13.457a.756.756 0 0 0 .748-.652l.006-.102V3.83a.757.757 0 0 0-.652-.748l-.102-.007z" />
    </svg>
)

const OptionsButton = ({ show, onClick }) => {
    if (!show) {
        return null;
    }
    
    return (
        <button
            className="sortable-list__move-button"
            onClick={onClick}
        >
            <OptionsIcon/>
            &nbsp;
        </button>
    );
}

const ArrowUpButton = ({ show, onClick, widgetShow = false, widgetArrowShow }) => {
    if (widgetShow === false) {
        if (show === undefined) {
            return <button className={"sortable-list__arrowup-button"} onClick={onClick}><ArrowUpIcon/>&nbsp;</button>;
        }
        return null;
    } else {
        if (widgetArrowShow === true) {
            return <button className={"sortable-list__arrowup-button"} onClick={onClick}><ArrowUpIcon/>&nbsp;</button>;
        }
        return null;
    }
}

const ArrowDownButton = ({ show, onClick, widgetShow = false, widgetArrowShow}) => {
    if (widgetShow === false) {
        if (show === undefined) {
            return <button className={"sortable-list__arrowdown-button"} onClick={onClick}> <ArrowDownIcon/>&nbsp;</button>;
        }
        return null;
    } else {
        if (widgetArrowShow === true) {
            return <button className={"sortable-list__arrowdown-button"} onClick={onClick}> <ArrowDownIcon/>&nbsp;</button>;
        }
        return null;
    }
}

const ArrowLeftButton = ({ _show, onClick, widgetShow = false, widgetArrowShow }) => {
    if (widgetShow === false) {
        return null;
    } else {
        if (widgetArrowShow === true) {
            return <button className={"sortable-list__arrowleft-button"} onClick={onClick} ><ArrowLeftIcon/>&nbsp;</button>;
        }
        return null;
    }
}

const ArrowRightButton = ({ _show, onClick, widgetShow = false, widgetArrowShow }) => { 
    if (widgetShow === false) {
        return null;
    } else {
        if (widgetArrowShow === true) {
            return <button className={"sortable-list__arrowright-button"} onClick={onClick} ><ArrowRightIcon/>&nbsp;</button>;
        }
        return null;
    }
}

const DeleteButton = ({ onClick }) => (
    <button
        className={"sortable-list__delete-button"}
        onClick={onClick}
    >
        <DeleteIcon/>
        &nbsp;
    </button>
)

export { OptionsButton, ArrowUpButton, ArrowDownButton, ArrowLeftButton, ArrowRightButton, DeleteButton };